import { signal } from "@preact/signals-react";

import poolForm from "componentsv2/form/pool";
import GridForm from "componentsv2/form/GridForm";
import PanelSide from "componentsv2/form/PanelSide";
import VerticalDivider from "componentsv2/widgets/VerticalDivider";
import {
  getInvisible,
  getValue,
  getLabel,
  getReadOnly,
  getRequired,
} from "componentsv2/tools/functions";
import { cn } from "tools/ui";

const pool = poolForm();

function Form({
  storeId,
  layout,
  record,
  update,
  parentRec,
  customStyle,
  handleButton,
  loading,
  reloadId,
  reload,
  // reloadId: reloadIdProp, Noo asi noooooo
}) {
  console.log(" ===== Construyendo Form record...", record);
  let index = 0;
  const formElements = [];
  const fields = layout.fields;

  function handleChange(fieldName, value, args) {
    const field = layout.fields[fieldName];
    field.name = fieldName;
    update({ record, storeId, field, value, loading, args });
  }

  function build(field, idx) {
    const Component = pool[field.widget || field.type] ?? field.component;

    if (!Component) {
      return;
    }

    const isReadOnly = getReadOnly(field, record?.active, parentRec);
    const isRequired = getRequired(field, record?.active, parentRec);

    const fieldDef = fields[field.name];
    const isDynamic =
      typeof field.getRequired === "function" ||
      typeof field.required === "function";

    if (isDynamic) {
      fieldDef._requiredSignal ??= signal(isRequired);
      fieldDef._requiredSignal.value = isRequired;
      field.required = fieldDef._requiredSignal;
    } else if (fieldDef?._requiredSignal) {
      field.required = fieldDef._requiredSignal;
    } else {
      field.required = signal(field.required || false);
    }

    const attrs = {
      ...field,
      field,
      model: layout.model,
      layout: field.layout ?? layout,
      record: record?.active,
      label: getLabel(field, record?.active, layout.model),
      onChange: handleChange,
      parentRec: parentRec, // optional
      error: Boolean(null && Boolean(!value)),
      data: signal(getValue(field, record?.active)),
      readOnly: isReadOnly,
      handleButton: handleButton,
      // This is necessary for trigger reload from the child when data changes
      // For example, when a field becomes required or invisible
      parentStoreId: storeId,
      reload: reload,
      reloadId: reloadId,
    };

    if (["cards", "one2many"].includes(field.widget) && field.layout) {
      attrs.layout = field.layout;
    }

    if (field.layout) {
      attrs.model = field.layout.model;
      attrs.parentRec = {
        layout,
        storeId: storeId, // This deprecated this var is now in attrs
        fieldName: field.name,
        target: field.layout.target,
        record: record?.active, // This deprecated use instead formStoreId
        // model: layout.model, // Model is inside the layout object
      };
    }
    let style;
    if (field.colSpan) {
      style = field.colSpan;
    }
    return <Component key={idx} {...attrs} style={cn(style)} />;
  }

  function getSchema(field_) {
    return { ...fields[field_.name], ...field_ };
  }

  function groupComponents(elements) {
    const createdElements = [];
    for (const formField of elements) {
      const component = getComponent(formField);
      if (component) createdElements.push(component);
    }
    return createdElements;
  }

  function getComponent(formField) {
    let component;
    const field = getSchema(formField);
    if (field.type !== "grid") {
      const isInvisible = getInvisible(field, record?.active);
      // console.log("isInvisible...", field.name, isInvisible);
      if (isInvisible) return;
    }

    // Widget is the type of component, example:
    // datetime, text, grid, char, many2one
    if (!field.elements) {
      index += 1;
      component = build(field, index);
    } else if (field.type === "grid") {
      const children = [];
      for (const fd of field.elements) {
        index += 1;
        const grField = getSchema(fd);
        const isInvisible = getInvisible(grField, record?.active);
        // console.log("isInvisible 2...", grField.name, isInvisible);
        if (isInvisible) continue;
        const element = build(grField, index);
        if (element) children.push(element);
      }
      index += 1;
      component = (
        <GridForm key={index} widget={field} style={field.style}>
          {children}
        </GridForm>
      );
    } else if (field.type === "tabs") {
      // FIXME: Implement tabs widget
      widget = "tabs";
    }
    return component;
  }

  let addSeparator = false;
  let style = "flex h-full gap-x-2 w-full";
  for (const field_ of layout.form) {
    let component;
    if (field_.type === "panel") {
      index += 1;
      if (addSeparator) {
        formElements.push(<VerticalDivider key={index} index={index} />);
        index += 1;
      }
      component = (
        <PanelSide key={index} widget={field_} stylePanel={field_.style}>
          {groupComponents(field_.elements)}
        </PanelSide>
      );
      addSeparator = true;
    } else {
      style = "grid sm:grid-cols-1 gap-x-2 w-full md:grid-cols-2 pb-14";
      component = getComponent(field_);
    }
    if (component) formElements.push(component);
  }

  return (
    <div id="form" className={cn(style, customStyle)}>
      {loading?.value ? null : formElements}
    </div>
  );
}

export default Form;
